'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var HeaderRow = function (props) {
    var headCells = props.headCells;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(styledComponents.StyledHeaderRow, null, headCells.map(function (headCell, i) { return (
        // eslint-disable-next-line react/no-array-index-key
        React__default.createElement(core.TableCell, { key: i }, headCell)); }))));
};

module.exports = HeaderRow;
